'use client';

import { Faq } from '@components/faq';

export function ByouFaq() {
    return (
        <Faq
            id='faq-offres-byou'
            title={
                <>
                    Vos questions fréquentes
                    <br />
                    sur les offres B&YOU
                </>
            }
            titleAlt='Vos questions fréquentes sur les offres B&YOU'
            url='byou-fai'
        />
    );
}
